@if (state(); as chip) {
  <span
    #tooltipOrigin="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="inline-flex max-w-full items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium"
    [class]="chip.colourClasses"
  >
    @if (chip.icon; as icon) {
      <mat-icon class="icon-xs !mr-0 shrink-0">{{ icon }}</mat-icon>
    }
    <span class="min-w-0">
      <span class="pr-1.5">{{ chip.label }}</span>
      @if (chip.amount; as amount) {
        <span class="font-bold">{{ amount }}</span>
      }
    </span>
    @for (marker of chip.markers; track marker) {
      <mat-icon class="icon-xs !mr-0 shrink-0">{{ marker }}</mat-icon>
    }
  </span>

  @if (!tooltipDisabled() && chip.tooltipSections.length) {
    <pt-custom-tooltip
      tooltipDelay="short"
      [target]="tooltipOrigin"
      [positions]="positions"
    >
      <ng-template ptCustomTooltipContent>
        <pr-deposit-chip-tooltip [chip]="chip" />
      </ng-template>
    </pt-custom-tooltip>
  }
}
